'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdStorage = function MdStorage(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm6.6 18.4v3.2h3.4v-3.2h-3.4z m-3.2 5v-6.8h33.2v6.8h-33.2z m6.6-11.8v-3.2h-3.4v3.2h3.4z m-6.6-5h33.2v6.8h-33.2v-6.8z m3.2 21.8v3.2h3.4v-3.2h-3.4z m-3.2 5v-6.8h33.2v6.8h-33.2z' })
        )
    );
};

exports.default = MdStorage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/storage.js
// module id = 3577
// module chunks = 0